__turbopack_context__.v({
  "container": "AutoHeight-module__v-0L9G__container",
});
